import { userDetail } from "../../config/userDetails";
import { globalApiHandler } from "../../services/services";


export const PREFERENCES = {
    getPreferences: {
        success: "GET_PREFERENCES"
    },
    putPreferences: {
        success: "PUT_PREFERENCES"
    },

}

export const getPreferences = (username=userDetail().username) => {
    let url = `/ntrac/user/preferences?username=${username}`
    return dispatch => {
      return  globalApiHandler(url, "get").then(response => {
            const data = response.data
            dispatch({type:PREFERENCES.getPreferences.success, data})
            return true
        }).catch((err)=>{
            dispatch({type: "SERVER_ERROR", data: err.data})
            return false
        })
    }
}

export const putPreferences = (preferenceInfo , username=userDetail().username ) => {
    console.log(preferenceInfo)
    let url = `/ntrac/user/preferences?username=${username}`
    return dispatch => {
      return  globalApiHandler(url, "put", preferenceInfo).then(response => {
            const data = response.data.data
            dispatch({type:PREFERENCES.putPreferences.success, data})
            return true
        }).catch((err)=>{
            dispatch({type: "SERVER_ERROR", data: err.data})
            return false
        })
    }
}


// WEBPACK FOOTER //
// ./src/modules/preferences/action.js